import {
  CLEAR_SKIP_INTRO_CONFIG,
  SET_SHOW_SKIP_INTRO,
  SET_SKIP_INTRO_VALUES,
} from '../actions/skipIntro/constants';

const initialState = {
  isShowSkipIntro: false,
  startSkipIntro: undefined,
  finishSkipIntro: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SHOW_SKIP_INTRO:
      return {
        ...state,
        isShowSkipIntro: action.payload,
      };
    case SET_SKIP_INTRO_VALUES:
      return {
        ...state,
        startSkipIntro: action.payload.startSkipIntro,
        finishSkipIntro: action.payload.finishSkipIntro,
      };
    case CLEAR_SKIP_INTRO_CONFIG:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
